import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AirportDropDownList } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { CarsWidgetFormType } from '../models/cars-widget-form.interfaces';
import { CarsWidget } from '../models/cars-widget.interface';

@Injectable({
  providedIn: 'root'
})
export class CarsLocationService {
  updateLocationContent(
    content: CarsWidget,
    form: FormGroup<CarsWidgetFormType>,
    locationSelected: AirportDropDownList
  ): void {
    content.locationContent.label = locationSelected.name;
    if (form && locationSelected?.code) {
      form.patchValue({ locationCode: locationSelected.code });
    }
  }
}
